import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createMethodsInput, deleteMethodsInput, getMethodsInputs, updateMethodsInput } from "../../api/methodsInput";
import { CreateMethodsInputRequest, UpdateMethodsInputRequest } from "../../types/model/methodsInput";

export const useCaptureMethodsInputs = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "methods-inputs"];

  const result = useQuery({
    queryKey,
    queryFn: () => getMethodsInputs(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: CreateMethodsInputRequest) => createMethodsInput(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ inputId, values }: { inputId: number; values: UpdateMethodsInputRequest }) => updateMethodsInput(inputId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (inputId: number) => deleteMethodsInput(inputId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    methodsInputsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createMethodsInput: createMutation.mutateAsync,
    updateMethodsInput: updateMutation.mutateAsync,
    deleteMethodsInput: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
